import React from "react";
import PropTypes from "prop-types";

const ErrorMessage = ({ message }) => {
  return <div className="invalid-feedback d-block">{message}</div>;
};

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ErrorMessage;
